import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function TradeTagListFilter() {
    const [filterCodigo, setfilterCodigo] = useState<FilterValuesProps>({
        property: 'idTagPecaMarketing',
        operator: 'eq',
        value: null,
        idProperty: 'idTagPecaMarketing',
    });
    
    const [nomeTag, setNomeTag] = useState<FilterValuesProps>({
        property: 'dsTagPecaMarketing',
        operator: 'like',
        idProperty: 'dsTagPecaMarketing',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterCodigo, setter: setfilterCodigo },
                { value: nomeTag, setter: setNomeTag },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código"
                    value={filterCodigo.value}
                    style={{ marginBottom: 20 }}
                    onChange={(e) => setfilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Tag"
                    value={nomeTag.value}
                    onChange={(e) => setNomeTag((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
